export default "__VITE_ASSET__DvJa6g6B__"